const APIS = {
  BRANCH: "/usermanagementservice/api/branch/",
  CREATE_BRANCH: "/logisticservice/api/branch/",
  STAFF: "/usermanagementservice/api/staff/",
  USER: "/usermanagementservice/api/user/",
  ADDRESS: "/usermanagementservice/api/address/",
  USER_PROFILE: "/usermanagementservice/api/user-profile/",
  GROUP: "/usermanagementservice/api/role/",
  LOCATION: "/logisticservice/api/location/",
  WAREHOUSE: "/logisticservice/api/warehouse/",
  CHANGE_PASSWORD: "/usermanagementservice/api/user/set-password/",
  PROFILE: "/usermanagementservice/api/profile/",
  BANK_DETAIL: "/usermanagementservice/api/bank-details/",
  DELIVERY_CHARGE_TEMPLATE: "/logisticservice/api/delivery-charge-template/",
  ACCOUNTS: "/mailboxservice/api/accounts/",
  ROLES: "/usermanagementservice/api/role/",
  ORGANIZATION: "/usermanagementservice/api/company/",
  ORG_LIST: "/usermanagementservice/api/organization/",
};

export default APIS;
